export default __webpack_public_path__ + "static/media/scan.1633e916.svg";